import apiurl from './apiurl';
const axios = require('axios');

const getDevicesByTenant=  async (idToken,tenant_id)  =>{

    const params = {tenant_id:tenant_id};

    

        // resolve(res);
        // return true;
        try {
            
            const result = await axios
            .get(apiurl+"devices", 
            {
            'headers': {
                "Content-Type": "application/json",
                'Authorization':"Bearer " + idToken
            },
            'params': {
                ...params
            },
            'crossdomain': true,
            })
            // console.log(result);
            return (result)
                        
            
            
        } catch (error) {
            
            console.log(error);
            throw (error)
            
        }
    
    
};

export default getDevicesByTenant;